import { Drawer, DrawerOverlayProps, DrawerProps } from "@mantine/core"
import { ReactNode } from "react"

import { IconDrawerClose } from "~/assets/icons/IconDrawerClose"

type Props = {
  children: ReactNode
  size?: string
  onClose: () => void
  onOpen?: () => void
  opened: boolean
  title?: string
  bg?: string
  overlayProps?: DrawerOverlayProps
} & DrawerProps
export function CustomDrawer({
  children,
  size,
  onClose,
  opened,
  title,
  bg,
  overlayProps = { backgroundOpacity: 0.5 },
  ...props
}: Props) {
  return (
    <Drawer.Root
      opened={opened}
      onClose={onClose}
      position="right"
      size={size}
      {...props}
    >
      <Drawer.Overlay {...overlayProps} />
      <Drawer.Content p={0} bg={bg}>
        <Drawer.Header p={0} bd="1px solid var(--mantine-color-gray-3)">
          <Drawer.CloseButton
            icon={
              <IconDrawerClose size={20} color="var(--mantine-color-gray-6)" />
            }
            style={{
              marginInlineStart: "20px",
            }}
          />
          {title && <Drawer.Title>{title}</Drawer.Title>}
        </Drawer.Header>
        <Drawer.Body p={0} h="100%">
          {children}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  )
}
